class CustomWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initWidget();
    this.initSubscriptionToggle();
    this.initSellingPlanUI();
    this.initPurchaseTypeToggle();
    this.handleInitialPurchaseType();
  }

  /* ===============================
     PURCHASE TYPE TOGGLE LOGIC
  =============================== */
  initPurchaseTypeToggle() {
    const purchaseRadios = this.querySelectorAll('input[name="purchase_type"]');
    const sellingPlanRadios = this.querySelectorAll('input[name="selling_plan"]');
    const qunatityContainer = this.querySelector('.qty-option-container');
    // Hide all qty-boxes when subscription is active
// this.querySelectorAll('.qty-box').forEach(box => box.style.display = 'none');

    purchaseRadios.forEach(radio => {
      radio.addEventListener("change", () => {
        if (radio.value === "subscription" && radio.checked) {
          qunatityContainer.style.display = "none";

          if (sellingPlanRadios.length) {
            sellingPlanRadios.forEach(r => r.checked = false);
            sellingPlanRadios[0].checked = true;
            sellingPlanRadios[0].dispatchEvent(new Event("change"));
          }

          const selectedPlan = this.querySelector('input[name="selling_plan"]:checked');
const months = selectedPlan ? parseInt(selectedPlan.dataset.months || 1) : 1;

this.selectedPack = months;
this.maxAllowed = months;

          this.packButtons.forEach(btn => {
            if (parseInt(btn.dataset.pack) !== 1) {
              btn.classList.remove("active");
              btn.disabled = true;
            } else {
              btn.classList.add("active");
              btn.disabled = false;
            }
          });

          this.variants.forEach((v, index) => {
            const qty = v.querySelector(".qty");
            if (qty) qty.textContent = index === 0 ? 1 : 0;
            // v.classList.toggle("active", index === 0);
          });

        } else {
          qunatityContainer.style.display = "block";
          sellingPlanRadios.forEach(r => r.checked = false);

          if (this.sellingPriceEl) this.sellingPriceEl.innerHTML = "";
           if (this.perbeg) this.perbeg.innerHTML = "";
          if (this.comparePriceEl) this.comparePriceEl.innerHTML = "";
          if (this.per_scoopPriceEl) this.per_scoopPriceEl.innerHTML = "";
          if (this.subInfoEl) this.subInfoEl.innerHTML = "";

          this.packButtons.forEach(btn => btn.disabled = false);

          this.selectedPack = 1;
          this.maxAllowed = 1;

          this.variants.forEach((v, index) => {
            const qty = v.querySelector(".qty");
            if (qty) qty.textContent = index === 0 ? 1 : 0;
            // v.classList.toggle("active", index === 0);
          });

       this.querySelectorAll(".qty-box").forEach(box => {
          box.style.display = this.selectedPack == 1 ? "none" : "flex";
        });



        }
      });
    });
  }

  handleInitialPurchaseType() {
    const selectedPurchase = this.querySelector('input[name="purchase_type"]:checked');
    if (!selectedPurchase) return;














    const sellingPlanRadios = this.querySelectorAll('input[name="selling_plan"]');

    if (selectedPurchase.value === "subscription") {
      this.selectedPack = 1;
      this.maxAllowed = 1;

      this.packButtons.forEach(btn => {
        if (parseInt(btn.dataset.pack) !== 1) {
          btn.classList.remove("active");
          btn.disabled = true;
        } else {
          btn.classList.add("active");
          btn.disabled = false;
        }
      });

      this.variants.forEach((v, index) => {
        const qty = v.querySelector(".qty");
        if (qty) qty.textContent = index === 0 ? 1 : 0;
        // v.classList.toggle("active", index === 0);
      });

      if (sellingPlanRadios.length) {
        sellingPlanRadios.forEach(r => r.checked = false);
        sellingPlanRadios[0].checked = true;
        sellingPlanRadios[0].dispatchEvent(new Event("change"));
      }

    } else {
      this.packButtons.forEach(btn => btn.disabled = false);
    }
  }

  /* ===============================
     SELLING PLAN UI
  =============================== */
initSellingPlanUI() {
  const radios = this.querySelectorAll('input[name="selling_plan"]');

  this.sellingPriceEl = this.querySelector('#selling_price');
    this.perbeg = this.querySelector('#per_beg');
  this.comparePriceEl = this.querySelector('#compare_price');
    this.per_scoopPriceEl = this.querySelector('#per-spoon');
  this.subInfoEl = this.querySelector('#sub_info_text');
// Hide all qty-boxes when subscription is active
this.querySelectorAll('.qty-box').forEach(box => box.style.display = 'none');


  if (!radios.length) return;

  const updateUI = (input) => {
    if (!input) return;
    const sellingPrice = input.dataset.sellingplan_price;    
    const sellingPriceMonthly = input.dataset.sellingplan_monthly_price;
    const comparePrice = input.dataset.price;
    const per_scoop = input.dataset.per_scoop;
    const subInfo = input.dataset.sub_info;

    if (this.sellingPriceEl) this.sellingPriceEl.innerHTML = sellingPriceMonthly;
    if (this.perbeg) this.perbeg.innerHTML = `${sellingPrice} / bag`;
    if (this.comparePriceEl) this.comparePriceEl.innerHTML = comparePrice;

const price = parseFloat(sellingPrice.replace(/[^0-9.]/g, ''));
const scoops = 40;
const pricePerScoop = (price / scoops).toFixed(2);
console.log(`$${pricePerScoop} / scoop`);
const per_scoop_price = `$${pricePerScoop} / scoop`;


    if (this.per_scoopPriceEl) this.per_scoopPriceEl.innerHTML = per_scoop_price;
    if (this.subInfoEl) this.subInfoEl.innerHTML = subInfo;
  };

  const checked = this.querySelector('input[name="selling_plan"]:checked');
  if (checked) updateUI(checked);

radios.forEach(radio => {
  radio.addEventListener('change', () => {

    updateUI(radio);

    const months = parseInt(radio.dataset.months || 1);

    // 🔥 SAME AS ONETIME LOGIC
    this.selectedPack = months;
    this.maxAllowed = months;

    // reset all variants
// reset all variants + force button states
this.variants.forEach(v => {
  const qty = v.querySelector(".qty");
  const plus = v.querySelector(".plus");
  const minus = v.querySelector(".minus");

  // reset qty
  if (qty) qty.textContent = 0;
  v.classList.remove("active");

  // ✅ force states
  if (minus) minus.disabled = true;   // disable all minus
  if (plus) plus.disabled = false;   // enable all plus
});

    // default select first variant with months qty
    // const first = this.variants[0];
    // if (first) {
    //   const qty = first.querySelector(".qty");
    //   if (qty) qty.textContent = months;
    //   first.classList.add("active");
    // }

    // qty box show/hide (same as onetime)
    this.querySelectorAll(".qty-box").forEach(box => {
      box.style.display = months === 1 ? "none" : "flex";
    });

    // ✅ auto switch to subscription
    const parentPurchaseTypeRadio = this.querySelector('input[name="purchase_type"][value="subscription"]');
    if (parentPurchaseTypeRadio && !parentPurchaseTypeRadio.checked) {
      parentPurchaseTypeRadio.checked = true;
      parentPurchaseTypeRadio.dispatchEvent(new Event('change'));
    }

  });
});


}

  /* ===============================
     SUBSCRIPTION TOGGLE LOGIC
  =============================== */
  initSubscriptionToggle() {
    const options = this.querySelectorAll(".subscription-option");

    options.forEach(option => {
      const radio = option.querySelector('input[type="radio"]');
      if (!radio) return;

      radio.addEventListener("change", () => {
        options.forEach(o => {
          o.classList.remove("active");
          const extra = o.querySelector(".extra-info");
          if (extra) extra.style.display = "none";
        });

        option.classList.add("active");
        const extra = option.querySelector(".extra-info");
        if (extra) extra.style.display = "block";

        this.updateSubscriptionPrice();
      });

      option.addEventListener("click", e => {
        if (e.target.tagName !== "INPUT") {
          radio.checked = true;
          radio.dispatchEvent(new Event("change"));
        }
      });
    });

    const checked = this.querySelector('input[name="selling_plan"]:checked');
    if (checked) checked.dispatchEvent(new Event("change"));
  }

  /* ===============================
     WIDGET LOGIC (VARIANTS & PACKS)
  =============================== */
  initWidget() {
    this.selectedPack = 1;
    this.maxAllowed = 1;


    this.packButtons = this.querySelectorAll("[data-pack]");
    this.variants = this.querySelectorAll(".variant-item");
    this.atcBtn = this.querySelector(".custom-add-to-cart");

    this.pricePerPackEl = this.querySelector("#price-per-pack");
    this.totalBottlePriceEl = this.querySelector("#pack-selling-plan");
    this.per_scoop_pricePerPackEl = this.querySelector("#pack-per-spoon");

    const resetAll = () => {
      this.variants.forEach(v => {
        const qty = v.querySelector(".qty");
        if (qty) qty.textContent = 0;
        v.classList.remove("active");
      });
    };

    const updateButtons = () => {
      const total = Array.from(this.variants).reduce(
        (sum, v) => sum + parseInt(v.querySelector(".qty")?.textContent || 0),
        0
      );
      this.variants.forEach(v => {
        const qty = parseInt(v.querySelector(".qty")?.textContent || 0);
        const plus = v.querySelector(".plus");
        const minus = v.querySelector(".minus");

        if (plus) plus.disabled = total >= this.maxAllowed;
        if (minus) minus.disabled = qty <= 0;
      });
    };

    this.updateSubscriptionPrice = () => {
      const selectedPlan = this.querySelector('input[name="selling_plan"]:checked');
      if (!selectedPlan) return;
      const price = selectedPlan.dataset.sellingplan_price;
      const headerPrice = this.querySelector(".subscription-header .sale_price_esa");
      if (price && headerPrice) headerPrice.innerHTML = price;
    };

    const selectPack1Default = () => {
      resetAll();
      const first = this.variants[0];
      if (first) {
        const qty = first.querySelector(".qty");
        if (qty) qty.textContent = 1;
        // first.classList.add("active");
      }
      updateButtons();
      this.updateSubscriptionPrice();
    };

    // ✅ Helper: Update subscription-pricing UI from pack's data attribute
this.updatePackPricingUI = (packButton) => {
  if (!packButton) return;
  const span = packButton.querySelector(".qty-option-text-save");
  if (!span) return;

  // Parse the dataset values as numbers
  let perBottlePrice = parseFloat(span.dataset.perBottlePrice) || 0;
  let totalPrice = parseFloat(span.dataset.totalBottlePrice) || 0;

  // Round to 2 decimal places
  perBottlePrice = Math.round(perBottlePrice * 100) / 100;
  totalPrice = Math.round(totalPrice * 100) / 100;

  // Get store currency
  const currencyMap = { USD: "$", INR: "₹", EUR: "€" };
  const currency = currencyMap[Shopify?.currency?.active] || "$";

  // Update per-pack price UI
  if (this.pricePerPackEl) this.pricePerPackEl.textContent = `${currency}${perBottlePrice} / bag`;
  if (this.totalBottlePriceEl) this.totalBottlePriceEl.textContent = `${currency}${totalPrice}`;

  // Calculate per-scoop price
  const scoopsPerBag = 40;
  const pricePerScoop = (perBottlePrice / scoopsPerBag).toFixed(2);

  // Display per-scoop price
  if (this.per_scoop_pricePerPackEl) {
    this.per_scoop_pricePerPackEl.textContent = `${currency}${pricePerScoop} / scoop`;
  }
};
    selectPack1Default();

    // Pack buttons click
    this.packButtons.forEach(btn => {




      btn.addEventListener("click", () => {
        const isSubscription = document.querySelector('input[name="purchase_type"]:checked')?.value === "subscription";
        if (isSubscription) return;

        this.packButtons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        this.selectedPack = parseInt(btn.dataset.pack) || 1;
        this.maxAllowed = this.selectedPack;

        this.variants.forEach(v => {
          const qty = v.querySelector(".qty");
          if (qty) qty.textContent = 0;
          v.classList.remove("active");
        });

        this.querySelectorAll(".qty-box").forEach(box => {
          box.style.display = this.selectedPack == 1 ? "none" : "flex";
        });

        if (this.selectedPack == 1) selectPack1Default();
        else updateButtons();

        // ✅ Update subscription pricing UI dynamically
        this.updatePackPricingUI(btn);

        this.updateSubscriptionPrice();
      });
    });

    // Variant logic (plus/minus buttons)
    this.variants.forEach(v => {
      const plus = v.querySelector(".plus");
      const minus = v.querySelector(".minus");
      const qtyEl = v.querySelector(".qty");

     plus?.addEventListener("click", e => {
  e.stopPropagation();

  const total = Array.from(this.variants).reduce(
    (sum, v) => sum + parseInt(v.querySelector(".qty")?.textContent || 0),
    0
  );

  if (total >= this.maxAllowed) return;

  qtyEl.textContent = parseInt(qtyEl.textContent) + 1;
  v.classList.add("active");

  updateButtons();
});

      minus?.addEventListener("click", e => {
        e.stopPropagation();
      
        const current = parseInt(qtyEl.textContent);
        if (current > 0) qtyEl.textContent = current - 1;
        if (parseInt(qtyEl.textContent) === 0) v.classList.remove("active");
        updateButtons();
      });

      v.addEventListener("click", () => {
        const isSubscription = document.querySelector('input[name="purchase_type"]:checked')?.value === "subscription";

      // behave same as pack=1 logic only when maxAllowed = 1
if (this.maxAllowed === 1) {
  this.variants.forEach(item => {
    item.classList.remove("active");
    const qty = item.querySelector(".qty");
    if (qty) qty.textContent = 0;
  });

  v.classList.add("active");
  const qty = v.querySelector(".qty");
  if (qty) qty.textContent = 1;
} else {
          if (this.selectedPack === 1) {
            this.variants.forEach(item => {
              item.classList.remove("active");
              const qty = item.querySelector(".qty");
              if (qty) qty.textContent = 0;
            });

            v.classList.add("active");
            const qty = v.querySelector(".qty");
            if (qty) qty.textContent = 1;
          }
        }
      });
    });

    // Initialize first active pack pricing
    const firstActivePack = this.querySelector(".qty-option-label.active");
    if (firstActivePack) this.updatePackPricingUI(firstActivePack);

    this.atcBtn?.addEventListener("click", e => {
      e.preventDefault();
      this.addToCartAndRedirect();
    });
  }

  async addToCartAndRedirect() {
  const items = [];

  this.variants.forEach(v => {
    const qty = parseInt(v.querySelector(".qty")?.textContent || 0);
    if (qty > 0) {
   const selectedPlan = this.querySelector('input[name="selling_plan"]:checked');
const months = selectedPlan ? parseInt(selectedPlan.dataset.months || 1) : 1;




items.push({
  id: v.dataset.variantId,
  quantity: qty , // 🔥 main logic
  ...(selectedPlan && { selling_plan: selectedPlan.value })
});
    }
  });

  if (!items.length) {
    alert("Please select product");
    return; 
  }

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    // ✅ Redirect directly to checkout instead of cart
    window.location.href = "/checkout";
  } catch (err) {
    console.error(err);
    alert("Something went wrong while adding to cart");
  }
}
}

/* REGISTER CUSTOM ELEMENT */
document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("custom-widget")) {
    customElements.define("custom-widget", CustomWidget);
  }
});






document.querySelectorAll('.variant-item').forEach(item => {

  const updateImage = (el) => {
    const imgUrl = el.dataset.variantImg;

    const mainImg = document.querySelector('xo-gallery-item img');
    const galleryItem = document.querySelector('xo-gallery-item');

    if (imgUrl && mainImg) {
      mainImg.src = imgUrl;
      mainImg.srcset = imgUrl;

      // better quality fix
      mainImg.removeAttribute('sizes');
    }

    if (galleryItem) {
      galleryItem.setAttribute('xo-src', imgUrl);
    }
  };

  // 👉 Variant click
  item.addEventListener('click', function () {
    document.querySelectorAll('.variant-item').forEach(i => i.classList.remove('active'));
    this.classList.add('active');

    updateImage(this);
  });

  // 👉 PLUS button
  const plusBtn = item.querySelector('.plus');
  const minusBtn = item.querySelector('.minus');

  if (plusBtn) {
    plusBtn.addEventListener('click', function (e) {
      e.stopPropagation(); // click bubble stop

      document.querySelectorAll('.variant-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');

      updateImage(item);
    });
  }

  // 👉 MINUS button
  if (minusBtn) {
    minusBtn.addEventListener('click', function (e) {
      e.stopPropagation();

      document.querySelectorAll('.variant-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');

      updateImage(item);
    });
  }

});